import React, { createContext, useMemo, ReactNode } from 'react';

interface BazaarVoiceContextType {
  showBazaarVoice: (locale: string) => boolean;
}

const BazaarVoiceContext = createContext<BazaarVoiceContextType>({
  showBazaarVoice: () => true,
});

interface BazaarVoiceProviderProps {
  children: ReactNode;
  showBazaarVoiceFunc?: (locale: string) => boolean;
}

function BazaarVoiceProvider({
  children,
  showBazaarVoiceFunc,
}: Readonly<BazaarVoiceProviderProps>) {
  const memoizedValue = useMemo(
    () => ({
      showBazaarVoice: showBazaarVoiceFunc || (() => true),
    }),
    [showBazaarVoiceFunc]
  );

  return (
    <BazaarVoiceContext.Provider value={memoizedValue}>
      {children}
    </BazaarVoiceContext.Provider>
  );
}

export { BazaarVoiceProvider, BazaarVoiceContext };
